import { default as ArtistDetail } from './component';
export default ArtistDetail;